import type { NewListingSource } from 'app/types/listing';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export const QUERY_THROTTLING_INITIAL_THRESHOLD = 10000;
export const QUERY_THROTTLING_REGULAR_THRESHOLD = 1000;

export const preferencesLoadedAtom = atomWithReset<boolean>(false);
export const addressesLoadedAtom = atomWithReset<boolean>(false);
export const addressCreatedAtom = atomWithReset<boolean>(false);
export const selfUserLoadedAtom = atomWithReset<boolean>(false);
export const queryThrottlingThresholdAtom = atomWithReset<number>(QUERY_THROTTLING_INITIAL_THRESHOLD);
export const newListingSourceAtom = atomWithReset<NewListingSource | undefined>(undefined);
export const bffDiscoverScreenLoadedAtom = atomWithReset<boolean>(false);
export const bffUserProfileLoadedAtom = atomWithReset<boolean>(false);

export function useResetQueryAtoms() {
  const resetPreferencesLoaded = useResetAtom(preferencesLoadedAtom);
  const resetAddressesLoaded = useResetAtom(addressesLoadedAtom);
  const resetAddressesCreated = useResetAtom(addressCreatedAtom);
  const resetSelfUserLoaded = useResetAtom(selfUserLoadedAtom);
  const resetQueryThrottlingThreshold = useResetAtom(queryThrottlingThresholdAtom);
  const resetNewListingSource = useResetAtom(newListingSourceAtom);
  const resetBffDiscoverScreenLoadedAtom = useResetAtom(bffDiscoverScreenLoadedAtom);
  const resetBffUserProfileLoadedAtom = useResetAtom(bffUserProfileLoadedAtom);
  return () => {
    resetPreferencesLoaded();
    resetAddressesLoaded();
    resetAddressesCreated();
    resetSelfUserLoaded();
    resetQueryThrottlingThreshold();
    resetNewListingSource();
    resetBffDiscoverScreenLoadedAtom();
    resetBffUserProfileLoadedAtom();
  };
}
